import { useLocation } from 'react-router-dom'

import { useEffect } from 'react'

import { FileQuestion } from 'lucide-react'

import { Button } from '@/components/ui/button'

export const NotFound = () => {
  const location = useLocation()

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname)
  }, [location.pathname])

  return (
    <div className="flex min-h-[70vh] items-center justify-center p-4">
      <div className="flex max-w-md flex-col items-center text-center">
        <div className="mb-6 flex size-40 items-center justify-center rounded-full bg-subdued" aria-hidden="true">
          <FileQuestion className="size-16 text-faint" strokeWidth={1.25} />
        </div>
        <h1 className="text-heading-md text-ink">Page not found</h1>
        <p className="mt-1 text-sm text-text-2">
          The page you're looking for doesn't exist or has moved.
        </p>
        <Button asChild className="mt-4">
          <a href="/">Go to home</a>
        </Button>
      </div>
    </div>
  )
}
